module.exports = __webpack_public_path__ + "static/img/nav_pic1.f0100bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/nav_pic1.jpg
// module id = S3l+
// module chunks = 37